import { useRef, useState, useEffect } from 'react';
import { PlayerTitle } from '@app/shared/ui/atoms/Multimedia';
import { MediaData } from '@app/shared/types/player';
import { MediaList } from '@app/shared/ui/molecules/Multimedia';

interface VideoPlayerProps {
  videos: MediaData[];
}

export const VideoPlayer = ({ videos }: VideoPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [currentIndex, setCurrentIndex] = useState(0);

  const currentVideo = videos[currentIndex];

  const changeVideo = (index: number) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.load();
  }, [currentIndex]);

  return (
    <div className="mx-auto text-foreground select-none space-y-2">
      {/*<video*/}
      {/*  ref={videoRef}*/}
      {/*  src={currentVideo.src}*/}
      {/*  className="rounded-lg w-full h-auto bg-black"*/}
      {/*  controls*/}
      {/*/>*/}
      <iframe
        width="100%"
        // height="210px"
        src={currentVideo.src}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />

      <PlayerTitle title={currentVideo.title} description={currentVideo.description} />
      <MediaList data={videos} currentIndex={currentIndex} onDataItemClick={changeVideo} />
    </div>
  );
};
